'use client'

import { useEffect } from 'react'
import { ErrorFallback } from '@/components/layout/error-boundary'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('App error:', error)
  }, [error])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <ErrorFallback 
        error={error} 
        resetError={reset}
        message="An unexpected error occurred in the application."
      />
    </div>
  )
}
